import { render, staticRenderFns } from "./HomeUserVip.vue?vue&type=template&id=7015725a&"
import script from "./HomeUserVip.vue?vue&type=script&lang=js&"
export * from "./HomeUserVip.vue?vue&type=script&lang=js&"
import style0 from "./HomeUserVip.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports